import React, { useState, useEffect } from "react";
import {Breadcrumb, Button, Card, Col, Container, Row } from "react-bootstrap";
import { ROUTES } from "../../constants/WebRouting";
import Confirm from "../Confirm";
import {useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import trasportApi from "../../api/trasportApi";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import FilesCreate from "../File/FilesCreate";
import RelatedListFiles from "../File/RelatedListFiles";
import moment from "moment";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import * as constants from "../../constants/CONSTANT";

// import RelatedListPriceBook from "../PriceBook/RelatedListPriceBook";
import PubSub from "pubsub-js";
import jwt_decode from "jwt-decode";
import Helmet from "react-helmet";
import Main from "../layout/Main";
// import PriceBookCreate from "../PriceBook/PriceBookCreate";
import Image from 'react-bootstrap/Image';
// import Permissionhelper from "../common/Permissionhelper";
import RelatedListSalesOrder from "./RelatedListSalesOrder";

const ProductView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [product, setProduct] = useState(location.state ? location.state : {});
  const [data, setData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [relatedListFiles, setRelatedListFiles] = useState(true);
  const [relatedListSales, setRelatedListSales] = useState(false);
  const [refreshTaskList, setRefreshPriceBook] = useState();
  const [modalShowFile, setModalShowFile] = useState(false);
  const [modalPriceBook, setModalPriceBook] = useState(false);
  const [modalShowEmail, setModalShowEmail] = useState(false);
  const [relatedListPriceBook, setrelatedListPriceBook] = useState(false);
  const [refreshFileList, setRefreshFileList] = useState();
  const [imageData, setImageData] = useState();

  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    setUserInfo(jwt_decode(localStorage.getItem("token")));
    fetchProduct();    
  }, []);

  const fetchProduct = () => {
    // Fetch product details and image data
    if (!product.id && location.hasOwnProperty("pathname") && location.pathname.split("/").length >= 3) {
      product.id = location.pathname.split("/")[2];
    }

    async function initProduct() {
      try {
        let result = await trasportApi.fetchProductById(product.id ? product.id : location.state.id);
        console.log("product data:", result);

        if(result){
          setProduct(result);
          setData(result);
        } else {
          setProduct({});
        }

        let productImageResult = await trasportApi.fetchPrimaryImages(product?.id);
        console.log("productImageResult == ",productImageResult)
        if (productImageResult?.id) {
          let productImageData = await trasportApi.downloadFiles(productImageResult?.id, "ProductImages");
          let reader = new FileReader();
          reader.readAsDataURL(productImageData);
          reader.onloadend = () => {
            console.log("reader result == ",reader.result)
            let base64data = reader.result;
            setImageData(base64data);
          };
        }
        else{
          //create this else part by shahir hussain for null primary image
          setImageData(null);
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    }
    initProduct();
  };



  const deleteProduct = async () => {
    // Delete product function
    const result = await trasportApi.deleteProductById(location?.state.id);
    if (result) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Record Deleted",
        message: "Record successfully deleted",
      });
      navigate(`/products`);
    }
  };

  const edit = () => {
    navigate(`/Products/${product.id}/e`, { state: product });
  };

  const handleSelect = (key) => {
    // Handle tab selection
    if (key === "pricebook") {
      setrelatedListPriceBook(true);
      setRelatedListFiles(false);
      setRelatedListSales(false)
    } else if (key === "files") {
      setRelatedListFiles(true);
      setrelatedListPriceBook(false);
      setRelatedListSales(false);
    }
     else if (key === "selling") {
      setRelatedListFiles(false);
      setrelatedListPriceBook(false);
      setRelatedListSales(true);
    }
  };

  const submitFiles = () => {
    // Submit files function
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    setModalPriceBook(false);
    fetchProduct(); 
  };

  const submitPriceBooks = () => {
    // Submit price books function
    setModalPriceBook(false);
    setModalShowEmail(false);
    setRefreshPriceBook(Date.now());
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.ProductView}</title>
        </Helmet>
      </>
      <Container>
        {product && (
          <>
            {modalShow && (
              <Confirm
                show={modalShow}
                onHide={() => setModalShow(false)}
                deleteProduct={deleteProduct}
                title="Confirm delete?"
                message="You are going to delete the record. Are you sure?"
                table="Product"
              />
            )}
            <Row className="view-form">
               <Col md={12} className="px-4">
                            <Breadcrumb>
                              <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                                Home
                              </Breadcrumb.Item>
                              <Breadcrumb.Item onClick={() => navigate(ROUTES.PRODUCT.LIST)}>
                               Products
                              </Breadcrumb.Item>
                            </Breadcrumb>
                          </Col>
              <Col></Col>
            </Row>
            <Row className="view-form gx-5 mx-auto">
              <Col lg={8}>
                <Row className="view-form-header align-items-center w-100">
                  <Col lg={8}>
                    <div className="d-flex align-items-center h-100 gap-3">
                      <h5 className="m-0">Product</h5>
                      <h5 className="m-0">
                      {product.product_name}
                      </h5>
                    </div>
                  </Col>
                  {/* <Col lg={8}>
                    Product
                    <h5>{product.Product_name}</h5>
                  </Col> */}
                  <Col lg={4} className="d-flex justify-content-end">
                    <Button className="btn-sm mx-2 btn-edit" onClick={() => edit(true)}>
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Button>
                    {/* {Permissionhelper.checkPermission(
                      constants.SUPER_ADMIN
                    ) && ( */}
                      <Button
                        className="btn-sm btn-delete"
                        variant="danger"
                        onClick={() => setModalShow(true)}
                      >
                        Delete
                      </Button>
                    {/* // )} */}
                    {/* <Button
                      className="float-right btn-sm"
                      onClick={() => setModalShowEmail(true)}
                      variant="success"
                      title="Send Email"
                    >
                      <i class="fa-regular fa-envelope mx-2"></i>
                    </Button> */}
                  </Col>
                </Row>

                <Row className="py-3 ibs-edit-form">
                  <Col lg={6}>
                    <label>Product Name</label>
                    <span>{product.product_name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Category</label>
                    <span>{product.name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Brand Name</label>
                    <span>{product?.brand_name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Product SKU</label>
                    <span>{product.sku}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Product Remark</label>
                    <span>{product.product_description}</span>
                  </Col>

                  {/* <Col lg={6}>
                    <label>Product External Source Name</label>
                    <span>{product.external_source_name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Product External Source Contact</label>
                    <span>{product.external_source_contact}</span>
                  </Col> */}
                  {/* {product.source === "external" && (
                    <>
                      <Col lg={6}>
                        <label>External Source Contact</label>
                        <span>{product.external_source_contact}</span>
                      </Col>

                      <Col lg={6}>
                        <label>Expected Date of Arrival</label>
                        <span>
                          {product.expected_date_of_arrival
                            ? moment(product.expected_date_of_arrival).format(
                                "DD MMM, yyyy"
                              )
                            : ""}
                        </span>
                      </Col>
                      <Col lg={6}>
                        <label>Source Order Date</label>
                        <span>
                          {product.source_order_date
                            ? moment(product.source_order_date).format(
                                "DD MMM, yyyy"
                              )
                            : ""}
                        </span>
                      </Col>
                      <Col lg={6}>
                        <label>PI Number</label>
                        <span>{product.pi_number}</span>
                      </Col>
                    </>
                  )} */}
                  <Col lg={12}>
                    <label>Created Date</label>
                    <span>
                      {moment(product.createddate).format("DD MMM, yyyy")}
                    </span>
                  </Col>
                </Row>
              </Col>
              <Col lg={4}>
                <div
                  className="card align-items-center shadow"
                  // style={{ width: "18rem" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title"
                      style={{
                        textAlign: "-webkit-center",
                        fontWeight: "900",
                      }}
                    >
                      {" "}
                      Product Image
                    </h5>
                    <hr></hr>
                    <div className="align-items-center">
                      {imageData && (
                        <Image
                          style={{
                            height: "150px",
                            width: "150px",
                            border: "12px",
                            marginLeft: "4px",
                          }}
                          src={imageData}
                          fluid
                          alt="No Image Found"
                        />
                      )}
                    </div>

                    <p
                      className="card-text"
                      style={{ textAlign: "center", marginTop: "24px" }}
                    >
                      {product?.product_name} {product?.sku}
                    </p>
                  </div>
                </div>
              </Col>

              {/* <Col>
                {imageData && <Image style={{ height: "300px", width: "300px" }} src={imageData} fluid />}
              </Col> */}
            </Row>

            <Card bg="light" text="light" className="mb-2 mt-4">
              <Card.Header className="d-flex justify-content-between">
                <Tabs
                  defaultActiveKey="files"
                  id="uncontrolled-tab-example"
                  onSelect={(key) => handleSelect(key)}
                >
                  <Tab eventKey="files" title="Files"></Tab>
                  {/* <Tab eventKey="selling" title="Services (Product Used)"></Tab> */}
                  {/* <Tab eventKey="pricebook" title="Pricebook"></Tab> */}
                </Tabs>

                {relatedListFiles && (
                  <Button
                    className="float-right btn-custom"
                    onClick={() => setModalShowFile(true)}
                    size="sm"
                  >
                    New File
                  </Button>
                )}
                {relatedListPriceBook && (
                  <Button
                    className="float-right btn-sm"
                    onClick={() => setModalPriceBook(true)}
                  >
                    New PriceBook
                  </Button>
                )}
                {modalShowFile && (
                  <FilesCreate
                    show={modalShowFile}
                    onHide={() => setModalShowFile(false)}
                    parent={product}
                    table="Product"
                    submitFiles={submitFiles}
                  />
                )}

                {/* {modalPriceBook && (
                  <PriceBookCreate
                    show={modalPriceBook}
                    onHide={() => setModalPriceBook(false)}
                    table="product"
                    submitPriceBooks={submitPriceBooks}
                    parentId={product.id}
                  />
                )} */}
              </Card.Header>
              <Card.Body>
                {relatedListFiles && (
                  <RelatedListFiles
                    refreshFileList={refreshFileList}
                    parent={product}
                    table="Product"
                    submitFiles={submitFiles} //Added by shivani
                  />
                )}
                {relatedListSales && (
                  <RelatedListSalesOrder
                  parent={product}
                  submitFiles={submitFiles}
                  />
                  // <RelatedListFiles
                  //   refreshFileList={refreshFileList}
                  //   parent={product}
                  //   table="Product"
                  //   submitFiles={submitFiles} //Added by shivani
                  // />
                )}
                {/* {relatedListPriceBook && (
                  <RelatedListPriceBook
                    refreshTaskList={refreshTaskList}
                    parent={product}
                  /> 
                )} */}
              </Card.Body>
            </Card>
          </>
        )}
      </Container>
    </Main>
  );
};

export default ProductView;